import { useCallback, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
    prepareHubspotData,
    prepareSignUpDate,
    sendToAmplitude,
    sendToHubspot,
    signUp,
    StepsType,
    useFormData
} from '../model';
import { Scan } from '../components';
import { LogPass } from './login-pass';
import { PersonalData } from './personal';
import s from './index.module.css';

type FormValues = {
    email: string;
    password: string;
    firstname: string;
    lastname: string;
    how_find_us: string | undefined;
};

export const SignUp = () => {
    const { email, setEmail, step, nextStep } = useFormData();
    const [part, setPart] = useState<boolean>(false);
    const [pass, setPass] = useState<string>('');
    const next = useCallback((value: string) => {
        setPass(value);
        setPart(true);
    }, []);

    const methods = useForm<FormValues>({
        values: {
            email,
            password: '',
            firstname: '',
            lastname: '',
            how_find_us: undefined
        }
    });
    const { handleSubmit: handleSubmitHook, setError } = methods;

    const handleSubmit = useCallback(
        async (data: FormValues) => {
            const payload = prepareSignUpDate({ ...data, password: pass });
            const { err } = await signUp(payload);

            if (err) setError('email', { type: 'invalid', message: err.error });
            else {
                setEmail(email);

                sendToAmplitude(`WALLARMCOM_AASM_SIGNUP_FORM_SUBMITTED`, {
                    email: data.email,
                    how_find_us: data.how_find_us || ''
                });
                await sendToHubspot(prepareHubspotData(data));

                nextStep('team');
            }
        },
        [pass]
    );

    return (
        <FormProvider {...methods}>
            <form className={s.form} onSubmit={handleSubmitHook(handleSubmit)}>
                <Scan step={step as StepsType} />

                {!part && <LogPass next={next} />}
                {part && (
                    <PersonalData
                        prev={() => setPart(false)}
                        onSubmit={handleSubmitHook(handleSubmit)}
                    />
                )}
            </form>
        </FormProvider>
    );
};
